import React from 'react';
import { Box, Layout } from '@capitalise/ui-design-system';
import { use100vh } from 'react-div-100vh';
import PropTypes from 'prop-types';

const NewLayoutNotLogged = ({ children }) => {
  const height = use100vh();

  return (
    <Box as="main" height={`${height}px`} width="100%">
      {children}
    </Box>
  );
};

NewLayoutNotLogged.propTypes = {
  children: PropTypes.any,
};

// With the new 2021 design system layout
export default function withNewLayoutNotLogged(Component) {
  return (props) => (
    <Layout>
      <NewLayoutNotLogged>
        <Component {...props} />
      </NewLayoutNotLogged>
    </Layout>
  );
}
